export default __webpack_public_path__ + "static/media/HealthOrange.4567aab0.svg";